export default class EmailService {

}
